export default __webpack_public_path__ + "static/media/delay_tab.90957a45.svg";